const MSG = {
    error: 'Something went wrong. Please contact administrator.',
    fileType:{
        title:'Invalid file type',
        message:'Only files with extension .jpeg, .jpg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv are allowed',
    },
    
    fileSize:{
        title:'Filesize limit',
        message:'Attachment must be less than or equal to 40mb',
    },

    general:"Only accepts gif, jpeg, png, pdf, xls, xlsx, csv and doc files with size not greater than 40mb."
}

const  allowedSize = 41943040;

const  allowedMimeTypes = [
    'image/gif',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv'
];

export {MSG, allowedSize, allowedMimeTypes}